import React from "react";
import { render } from "react-dom";
import App from "./components/App";
import "font-awesome/css/font-awesome.css";

render(<App />, document.querySelector("#main"));



// WEBPACK FOOTER //
// ./src/index.js